import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { downloadFile } from 'ui-component/custom/FileMngr';
import { followUpStepActions } from './slice';
import capabilities from './capabilities';

export const ApiFollowUpStepsApplyTransItem = async ({
    id,
    transition = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(followUpStepActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/followupsteps/applytrans/${transition}/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(followUpStepActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(followUpStepActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(followUpStepActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(followUpStepActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiFollowUpStepsFileManagerIndex = async ({
    id = -1,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/followupsteps/filemanager/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers }
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiFollowUpStepsFileManagerUpload = async ({
    id = -1,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/followupsteps/filemanager/upload/${id}?${params}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'multipart/form-data' }
        })
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiFollowUpStepsFileManagerDownload = async ({
    id = -1,
    params = '',
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post(`workmgmt/followupsteps/filemanager/download/${id}?${params}`, data, { ...config, responseType: 'blob' })
        .then((response) => {
            if (response.status === 200) {
                const contentType = response.headers['content-type'];
                const contentDisposition = response.headers['content-disposition'];
                let fileName = 'names' in data ? data.names[0] : 'download';

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/);
                    if (match) {
                        fileName = match[1];
                    }
                }

                downloadFile(response.data, fileName, contentType);

                if (typeof successCallback === 'function') {
                    successCallback(response.data);
                }
            } else if (typeof errorCallback === 'function') {
                errorCallback();
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
